import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {alt} from './alt.js';
import {
    switchOutput,
    execute,
} from './lang.js';
import {threshold} from './threshold.js';

class ThresholdEffect extends ScriptingEffect {
    constructor(track) {
        super("Threshold", track);
        this.clear();
        this.newVar("threshold", 4, 1, 64);
        this.newVar("time", 4, 1, 64);

        this.numberOfOutputs = 2;
    }

    get documentation() {
        return [
            "Switches the output of the effect once a threshold of triggers is reached and remains switched until an amount of time has passed."
        ];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            threshold((s) => s.velocity,
                      this.var("threshold"),
                      this.var("time")));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new ThresholdEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default ThresholdEffect;
